import React, { lazy, Suspense, useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService, { SELECTED_TENANT_STORAGE_KEY } from "services/MenuService";

export const AppViews = () => {
	const [sessionReady, setSessionReady] = useState(false);

	useEffect(() => {
		let isMounted = true;
		const populateMenu = async () => {
			if (!JwtAuthService.isLogged()) {
				if (isMounted) {
					setSessionReady(true);
				}
				return;
			}
			try {
				const hasStoredTenant = Boolean(
					localStorage.getItem(SELECTED_TENANT_STORAGE_KEY),
				);
				await MenuService.bootstrapSession({
					preserveStored: hasStoredTenant,
				});
			} catch (e) {
				console.error(e);
			} finally {
				if (isMounted) {
					setSessionReady(true);
				}
			}
		};

		populateMenu();

		return () => {
			isMounted = false;
		};
	}, []);

	if (!sessionReady) {
		return <Loading cover="content" />;
	}

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard`}
					component={lazy(() => import(`./dashboard`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-usuarios`}
					component={lazy(() => import(`./lista-usuarios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario/:id`}
					component={lazy(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario`}
					component={lazy(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-grupos-usuario`}
					component={lazy(() => import(`./lista-grupos-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario/:id`}
					component={lazy(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario`}
					component={lazy(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-departamentos`}
					component={lazy(() => import(`./lista-departamentos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-categorias`}
					component={lazy(() => import(`./lista-categorias`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-bases`}
					component={lazy(() => import(`./lista-bases`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-workers`}
					component={lazy(() => import(`./lista-workers`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/worker/:id`}
					component={lazy(() => import(`./worker`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-tenants`}
					component={lazy(() => import(`./lista-tenants`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/worker`}
					component={lazy(() => import(`./worker`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/base/:id`}
					component={lazy(() => import(`./base`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/departamento/:id`}
					component={lazy(() => import(`./departamento`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/departamento`}
					component={lazy(() => import(`./departamento`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-regras`}
					component={lazy(() => import(`./lista-regras`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-regras-usuario`}
					component={lazy(() => import(`./lista-regras-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-regras-alertas`}
					component={lazy(() => import(`./lista-regras-alertas`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-validacoes-empresas`}
					component={lazy(() => import(`./lista-validacoes-empresas`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-pendencias-fornecedor`}
					component={lazy(() =>
						import(`./lista-pendencias-fornecedor`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-logs-execucao-regra`}
					component={lazy(() => import(`./lista-logs-execucao-regra`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-dados-extra/:id`}
					component={lazy(() => import(`./lista-dados-extra`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/regra/:id`}
					component={lazy(() => import(`./regra`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/regra`}
					component={lazy(() => import(`./regra`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-empresas`}
					component={lazy(() => import(`./lista-empresas`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/vinculo-regra-empresa`}
					component={lazy(() => import(`./vinculo-regra-empresa`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/rodar-regras/novo`}
					component={lazy(() => import(`./rodar-regras/Formulario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/rodar-regras/:id`}
					component={lazy(() => import(`./rodar-regras/Formulario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/rodar-regras`}
					component={lazy(() => import(`./rodar-regras`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/empresa/:id/funcionarios`}
					component={lazy(() => import(`./empresa-funcionarios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/empresa/:id`}
					component={lazy(() => import(`./empresa`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/configuracoes-gerais`}
					component={lazy(() => import(`./configuracoes-gerais`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/configuracao-notas`}
					component={lazy(() => import(`./configuracao-notas`))}
				/>
				{/*<Route*/}
				{/*	path={`${APP_PREFIX_PATH}/execucao-rapida`}*/}
				{/*	component={lazy(() => import(`./execucao-rapida`))}*/}
				{/*/>*/}
				<Route
					path={`${APP_PREFIX_PATH}/alertas-regra/:id`}
					component={lazy(() => import(`./alertas-regra`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/empresas-regra/:id`}
					component={lazy(() => import(`./empresas-regra`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/alertas-empresa/:id`}
					component={lazy(() => import(`./alertas-empresa`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tenant/:schema`}
					component={lazy(() => import(`./tenant`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tenant`}
					component={lazy(() => import(`./tenant`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/whatsapp-config/:id`}
					component={lazy(() => import(`./whatsapp-config/detalhe`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/whatsapp-config`}
					component={lazy(() => import(`./whatsapp-config`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/whatsapp`}
					component={lazy(() => import(`./whatsapp-inbox`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/funil-vendas`}
					component={lazy(() => import(`./funil-vendas`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/agendamentos/novo`}
					component={lazy(() => import(`./agendamentos/Formulario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/agendamentos/:id`}
					component={lazy(() => import(`./agendamentos/Formulario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/agendamentos`}
					component={lazy(() => import(`./agendamentos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/agenda`}
					component={lazy(() => import(`./agenda`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/diagnostico-fiscal`}
					component={lazy(() => import(`./diagnostico-fiscal`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/gestao-cfop`}
					component={lazy(() => import(`./gestao-cfop`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-fornecedores/:codigo`}
					component={lazy(() => import(`./lista-fornecedores`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/fiscal/cfop`}
					render={() => <Redirect to={`${APP_PREFIX_PATH}/gestao-cfop`} />}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/fiscal/log-cfop`}
					component={lazy(() => import(`./portal-fiscal-log-cfop`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/fiscal/log-auto-cfop`}
					component={lazy(() => import(`./portal-fiscal-log-auto-cfop`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cruzamento-notas-saida`}
					component={lazy(() => import(`./cruzamento-notas-saida`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/fiscal/cruzamento-saida`}
					render={() => (
						<Redirect
							to={`${APP_PREFIX_PATH}/cruzamento-notas-saida`}
						/>
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cruzamento-notas`}
					component={lazy(() => import(`./cruzamento-notas`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/fiscal/cruzamento`}
					render={() => (
						<Redirect to={`${APP_PREFIX_PATH}/cruzamento-notas`} />
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/fiscal/log-cruzamento`}
					component={lazy(() => import(`./portal-fiscal-log-cruzamento`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/contabil/bloqueios`}
					component={lazy(() => import(`./portal-contabil-bloqueios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/contabil/log-bloqueios`}
					component={lazy(() => import(`./portal-contabil-log-bloqueios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/societario/contratos`}
					component={lazy(() => import(`./portal-societario-contratos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/societario/atualizador`}
					component={lazy(() => import(`./portal-societario-atualizador`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/societario/certificados`}
					component={lazy(() => import(`./portal-societario-certificados`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/gestao/visao-carteira`}
					component={lazy(() => import(`./portal-gestao-visao-carteira`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/gestao/financeiro`}
					component={lazy(() => import(`./portal-em-breve`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/gestao/situacao-modulos`}
					component={lazy(() => import(`./portal-gestao-situacao-modulos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/rotinas/tipos`}
					component={lazy(() => import(`./portal-rotinas-tipos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/rotinas/matriz`}
					component={lazy(() => import(`./portal-rotinas-matriz`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/rotinas/domicilios`}
					component={lazy(() => import(`./portal-rotinas-domicilios`))}
				/>
				<Route
					exact
					path={`${APP_PREFIX_PATH}/portal/rotinas`}
					component={lazy(() => import(`./portal-rotinas-painel`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/avisos/omie`}
					component={lazy(() => import(`./portal-em-breve`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/avisos/zen`}
					component={lazy(() => import(`./portal-em-breve`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/portal/folha`}
					component={lazy(() => import(`./portal-em-breve`))}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/lista-regras-alertas`}
				/>
			</Switch>
		</Suspense>
	);
};

export default React.memo(AppViews);
